export default {
  title: 'Valutazione transfrontaliera',
  noLongerRequired:
    'La pre-approvazione non è più necessaria per le valutazioni transfrontaliere.',
  noLongerRequiredDescription:
    'La valutazione viene ora esaminata da Vamoz e rilasciata dalle risorse umane. Non è richiesta alcuna azione da parte tua e puoi chiudere questa finestra.'
};
